//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-action-invite imports
import { IContainer, IProps, IState } from "./SuggestionActionInvite.d";
import { fragments } from "./SuggestionActionInvite.gql";
import { CardButton } from "@components/card";
// other internals
import { snackBarOpen } from "@actions/snack-bar.actions";
import { updateOrgInvite } from "@mutations";
// state
import { IReduxState } from "@reducers/root.reducer";
// material-ui
import { Send } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionActionInviteCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      sending: false,
    };
  }

  private onSuccess = () => {
    const { actionCallback } = this.props;

    this.setState({ sending: false });
    this.props.snackBarOpen("Invitation sent!");

    if (actionCallback) {
      actionCallback();
    }
  };

  private onFailure = () => {
    const { actionCallback } = this.props;

    this.setState({ sending: false });
    this.props.snackBarOpen("Invitation failed to send :(");

    if (actionCallback) {
      actionCallback();
    }
  };

  private sendInvite = () => {
    const { org, payload } = this.props;
    const { calendarId } = payload;
    if (!this.state.sending) {
      this.setState({ sending: true });
      updateOrgInvite(
        this.props.relay.environment,
        { orgRelayId: org.id, calendarIds: [calendarId] },
        this.onSuccess,
        this.onFailure,
      );
    }
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { label } = this.props;
    const { sending } = this.state;
    return (
      <CardButton
        flat
        label={sending ? "Sending..." : label}
        onClick={this.sendInvite}
        disabled={sending}
        icon={<Send />}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SuggestionActionInviteRedux = connect(mapStateToProps, {
  snackBarOpen,
})(SuggestionActionInviteCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionActionInvite = createFragmentContainer<IContainer>(
  SuggestionActionInviteRedux,
  fragments,
);
